import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function TimeSlots({ timeSlots, tabId }) {
  const { state: stateUsers } = useUsersContext();
  const { user } = stateUsers;

  useEffect(() => {
    const tab = document.getElementById(tabId);
    const container = tab.querySelector('.time-slots');
    const btnMoveLeft = tab.querySelector('.btn-move-left');
    const btnMoveRight = tab.querySelector('.btn-move-right');

    if (container.scrollLeft === 0) {
      btnMoveLeft.disabled = true;
      btnMoveLeft.querySelector('.chevron-icon').classList.add('bg-gray-600');
    } else {
      btnMoveLeft.disabled = false;
      btnMoveLeft.querySelector('.chevron-icon').classList.remove('bg-gray-600');
    }

    if ((container.scrollWidth - (container.scrollLeft + container.offsetWidth)) <= 1) {
      btnMoveRight.disabled = true;
      btnMoveRight.querySelector('.chevron-icon').classList.add('bg-gray-600');
    } else {
      btnMoveRight.disabled = false;
      btnMoveRight.querySelector('.chevron-icon').classList.remove('bg-gray-600');
    }
  }, []);

  return (
    <>
      <div className="my-3 fw-semibold">
        Time Slots
        {user && (
          <>
            {' '}
            <small className="fw-light">
              {user.attributes.time_zone_offset}
            </small>
          </>
        )}
      </div>

      <div className="time-slots-wrapper d-flex align-items-center">
        <Button
          variant="link"
          className="btn-move-left"
          onClick={(e) => {
            const container = e.target.closest('.time-slots-wrapper').querySelector('.time-slots');

            container.scrollBy({ left: -100, behavior: 'smooth' });
          }}
        >
          <IconWithText
            iconClassName="chevron-icon small-icon"
            iconStyle={{ transform: 'rotate(90deg)' }}
          />
        </Button>

        <div className="overflow-hidden">
          <div
            className="time-slots d-grid gap-2"
            style={{
              gridAutoColumns: 'max-content',
              gridTemplateRows: '1fr',
              overflowX: 'scroll',
              scrollbarWidth: 'none',
            }}
            onScroll={(e) => {
              const container = e.target;
              const btnMoveLeft = container.closest('.time-slots-wrapper').querySelector('.btn-move-left');
              const btnMoveRight = container.closest('.time-slots-wrapper').querySelector('.btn-move-right');

              if (container.scrollLeft === 0) {
                btnMoveLeft.disabled = true;
                btnMoveLeft.querySelector('.chevron-icon').classList.add('bg-gray-600');
              } else {
                btnMoveLeft.disabled = false;
                btnMoveLeft.querySelector('.chevron-icon').classList.remove('bg-gray-600');
              }

              if ((container.scrollWidth - (container.scrollLeft + container.offsetWidth)) <= 1) {
                btnMoveRight.disabled = true;
                btnMoveRight.querySelector('.chevron-icon').classList.add('bg-gray-600');
              } else {
                btnMoveRight.disabled = false;
                btnMoveRight.querySelector('.chevron-icon').classList.remove('bg-gray-600');
              }
            }}
          >
            {timeSlots.map((timeSlot) => (
              <div
                key={timeSlot.start}
                className="btn bg-gray-100 rounded text-nowrap"
                style={{
                  gridRow: 1,
                  gridColumn: 'auto',
                  cursor: 'auto',
                }}
              >
                <small>{timeSlot.hours}</small>
              </div>
            ))}
          </div>
        </div>

        <Button
          variant="link"
          className="btn-move-right"
          onClick={(e) => {
            const container = e.target.closest('.time-slots-wrapper').querySelector('.time-slots');

            container.scrollBy({ left: 100, behavior: 'smooth' });
          }}
        >
          <IconWithText
            iconClassName="chevron-icon small-icon"
            iconStyle={{ transform: 'rotate(-90deg)' }}
          />
        </Button>
      </div>
    </>
  );
}

TimeSlots.propTypes = {
  timeSlots: PropTypes.arrayOf(PropTypes.object).isRequired,
  tabId: PropTypes.string.isRequired,
};
